import { Component, Emit, Prop, Vue } from "vue-property-decorator";

@Component
export default class ViewRouter extends Vue {
	@Prop() public isVisible!: boolean;
	@Prop() public title!: string;
	@Prop() public path!: string;
	private onClickRouter(): void {
		// TODO トップページで表示される汎用的なルータにしたい。/channelsへの振り分けなども。
		this.$router.push(this.path);
	}
}
